export interface Work {
  slug: string;
  title: string;
  status: string;
  genre: string[];
  intro: string;
  cover: string;
  chapters: string;
  rating: number;
  mainCharacters: string[];
  tags: string[];
  featured?: boolean;
}

export const works: Work[] = [
  {
    slug: "yueye-yaohua",
    title: "月夜妖华",
    status: "连载中",
    genre: ["宫廷", "恋爱", "奇幻"],
    intro:
      "月庭山庄收留了一只银发小猫妖，白天她慵懒撒娇，月圆之夜却会现出妖形、露出锋芒。青梅竹马的少主与这只『娇气』猫妖，从吵吵闹闹到并肩守护，藏着整个月庭的秘密。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20a%20moonlit%20royal%20garden%20with%20a%20silver%20cat-eared%20fairy%20girl%20and%20a%20young%20master%20standing%20under%20a%20giant%20full%20moon%2C%20soft%20pastel%20pink%20and%20cream%20palette%2C%20romantic%20fantasy%20manhwa%20style%2C%20high%20quality%20illustration&width=640&height=840&seq=work-yueye&orientation=portrait",
    chapters: "134话",
    rating: 9.4,
    mainCharacters: ["尹汐月", "白钰"],
    tags: ["宫廷", "猫妖", "欢喜冤家"],
    featured: true,
  },
  {
    slug: "humian-wangfei",
    title: "狐面王妃",
    status: "已完结",
    genre: ["宫斗", "谋略", "奇幻"],
    intro:
      "为报灭族之仇，九尾狐戴上面具入宫成为王妃。人前温婉贤良，人后运筹帷幄，冷面帝王与她从互相试探到生死相托。一场宫闱之争，裹着九尾狐千年的执念与深情。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20an%20elegant%20crimson%20haired%20nine-tailed%20fox%20queen%20wearing%20a%20luxurious%20red%20royal%20hanbok%20and%20a%20white%20fox%20mask%2C%20grand%20palace%20throne%20room%20background%2C%20red%20and%20gold%20dramatic%20palette%2C%20romantic%20fantasy%20manhwa%20style%2C%20high%20quality%20illustration&width=640&height=840&seq=work-humian&orientation=portrait",
    chapters: "全198话",
    rating: 9.6,
    mainCharacters: ["姜梦萝", "玄渊"],
    tags: ["宫斗", "九尾狐", "强强"],
    featured: true,
  },
  {
    slug: "bingyue-huajia",
    title: "冰月花嫁",
    status: "连载中",
    genre: ["治愈", "恋爱", "奇幻"],
    intro:
      "生于永冬之国的冰灵公主，天生情感淡薄。为两国联姻远嫁他乡，却遇见一个愿意用整个春天温暖她的花妖。冰封的心，在一次次笨拙的心动里悄然融化。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20a%20pale%20snow%20princess%20with%20ice-blue%20hair%20and%20a%20warm%20flower%20spirit%20boy%20standing%20together%2C%20one%20side%20frozen%20winter%20one%20side%20blooming%20spring%2C%20soft%20pastel%20blue%20and%20pink%20palette%2C%20healing%20romantic%20fantasy%20manhwa%20style%2C%20high%20quality%20illustration&width=640&height=840&seq=work-bingyue&orientation=portrait",
    chapters: "76话",
    rating: 9.1,
    mainCharacters: ["林千雪", "陆之遥"],
    tags: ["治愈", "冰雪", "慢热"],
  },
  {
    slug: "yese-bianlidian",
    title: "夜色便利店",
    status: "连载中",
    genre: ["日常", "治愈", "都市"],
    intro:
      "一家只在夜晚营业、专供妖怪购物的便利店。店长是个元气满满的普通女孩，白天上班、夜里守店，用一杯热茶和一句问候，温暖着整条夜街的妖妖们。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20a%20cozy%20night%20convenience%20store%20with%20warm%20glowing%20lights%20and%20a%20cheerful%20brown%20haired%20shopkeeper%20girl%20greeting%20a%20tall%20mysterious%20owl%20customer%2C%20warm%20cozy%20night%20palette%2C%20slice%20of%20life%20fantasy%20manhwa%20style%2C%20high%20quality%20illustration&width=640&height=840&seq=work-yese&orientation=portrait",
    chapters: "112话",
    rating: 9.2,
    mainCharacters: ["朴夏恩", "夜枭"],
    tags: ["日常", "都市", "治愈"],
    featured: true,
  },
  {
    slug: "yinghua-yaoqi",
    title: "樱花妖契",
    status: "已完结",
    genre: ["纯爱", "治愈", "奇幻"],
    intro:
      "被少年救下的樱花精灵，主动献上自己的契约。她把『守护』写进骨子里，而他把她从漫长的孤独里捞了出来。一场双向奔赴的治愈之旅，温柔到骨子里。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20a%20soft%20pink%20haired%20sakura%20spirit%20girl%20and%20a%20gentle%20boy%20under%20a%20blooming%20cherry%20blossom%20tree%20with%20floating%20petals%2C%20soft%20dreamy%20pastel%20palette%2C%20healing%20pure%20romance%20manhwa%20style%2C%20high%20quality%20illustration&width=640&height=840&seq=work-yinghua&orientation=portrait",
    chapters: "全156话",
    rating: 9.3,
    mainCharacters: ["崔宁儿", "顾言"],
    tags: ["纯爱", "樱花", "治愈"],
  },
  {
    slug: "shanhai-lingge",
    title: "山海灵歌",
    status: "连载中",
    genre: ["冒险", "养成", "奇幻"],
    intro:
      "一只从《山海经》里跑出来的小灵兽误入人间，被温和的人师收留。什么都不懂的她一边学人间烟火，一边用自己的方式守护身边的人。一场关于成长与羁绊的冒险。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20a%20playful%20white%20fox%20spirit%20girl%20with%20fluffy%20ears%20and%20tail%20sitting%20on%20a%20giant%20mythical%20beast%2C%20with%20a%20warm%20young%20scholar%20beside%20her%2C%20vibrant%20mythical%20landscape%2C%20warm%20bright%20palette%2C%20adventure%20fantasy%20manhwa%20style%2C%20high%20quality%20illustration&width=640&height=840&seq=work-shanhai&orientation=portrait",
    chapters: "89话",
    rating: 8.8,
    mainCharacters: ["白狐姬", "林泽"],
    tags: ["冒险", "灵兽", "养成"],
  },
  {
    slug: "fenghuang-niepan",
    title: "凤凰涅槃",
    status: "已完结",
    genre: ["强强", "宫斗", "奇幻"],
    intro:
      "凤族掌上明珠一朝遭难涅槃重生。骄傲张扬的大小姐在烈火里炼出沉稳果决，与宿敌凤凰天骄从针锋相对到生死相托，写下一段涅槃与新生的传奇。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20a%20proud%20vermilion%20haired%20phoenix%20princess%20with%20golden%20feather%20ornaments%20rising%20from%20golden%20fire%2C%20surrounded%20by%20phoenix%20wings%2C%20dramatic%20red%20and%20gold%20palette%2C%20bold%20epic%20fantasy%20manhwa%20style%2C%20high%20quality%20illustration&width=640&height=840&seq=work-fenghuang&orientation=portrait",
    chapters: "全142话",
    rating: 9.0,
    mainCharacters: ["宋昭", "厉寒"],
    tags: ["强强", "凤凰", "宫斗"],
  },
  {
    slug: "wudu-yaotan",
    title: "雾都妖谭",
    status: "连载中",
    genre: ["都市", "怪谈", "悬疑"],
    intro:
      "白天是普通教师，夜里是游走雾都的阴阳师。平静表象下藏着整座城市的妖怪秘辛，冷静的她与雾妖一起，解决一桩桩都市怪谈背后的执念与温柔。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20a%20calm%20black%20haired%20female%20exorcist%20holding%20a%20talisman%20in%20a%20misty%20dark%20city%20night%2C%20a%20shadowy%20mist%20spirit%20beside%20her%2C%20moody%20dark%20teal%20and%20indigo%20palette%2C%20urban%20mystery%20fantasy%20manhwa%20style%2C%20high%20quality%20illustration&width=640&height=840&seq=work-wudu&orientation=portrait",
    chapters: "67话",
    rating: 8.9,
    mainCharacters: ["藤原纱绫", "雾弥"],
    tags: ["都市", "怪谈", "悬疑"],
  },
  {
    slug: "xingguang-shitang",
    title: "星光食堂",
    status: "连载中",
    genre: ["日常", "治愈", "美食"],
    intro:
      "妖怪界深夜食堂的精灵厨师，一人一店一灶，用一道道料理抚慰来来往往妖怪的心事。美食与温暖交织，每一夜都有人带着伤痕而来、带着满足而归。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20a%20gentle%20green%20haired%20elf%20chef%20girl%20serving%20steaming%20dishes%20in%20a%20cozy%20starry%20night%20restaurant%2C%20warm%20golden%20glow%2C%20food%20and%20healing%20slice%20of%20life%20manhwa%20style%2C%20high%20quality%20illustration&width=640&height=840&seq=work-xingguang&orientation=portrait",
    chapters: "54话",
    rating: 8.7,
    mainCharacters: ["郑小满", "阿岚"],
    tags: ["美食", "日常", "治愈"],
  },
  {
    slug: "hanyue-jiange",
    title: "寒月剑歌",
    status: "连载中",
    genre: ["武侠", "恋爱", "奇幻"],
    intro:
      "由千年寒剑化形的剑妖，初时冷若冰霜只知剑不懂情。直到遇见那个江湖浪子，才学会了何为心动。一柄寒剑、一段江湖，剑妖与浪子并肩同行。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20a%20heroic%20sword%20spirit%20girl%20with%20long%20black%20hair%20holding%20a%20frost%20sword%20beside%20a%20roguish%20handsome%20wuxia%20boy%2C%20moonlit%20snowy%20mountain%20background%2C%20cool%20white%20and%20blue%20palette%2C%20wuxia%20romantic%20fantasy%20manhwa%20style%2C%20high%20quality%20illustration&width=640&height=840&seq=work-hanyue&orientation=portrait",
    chapters: "48话",
    rating: 8.8,
    mainCharacters: ["李寒衣", "沈聿"],
    tags: ["武侠", "剑妖", "江湖"],
  },
];

export function getWork(slug: string): Work | undefined {
  return works.find((w) => w.slug === slug);
}